<template>
  <div>
    <EtsyTransferShopHead
            :showFilter="showFilter"
            :countFilterParams="countFilterParams"
            @toggleFilter="toggleFilter"
            @filter="$emit('filter')"
            @changeTab="(data) => $emit('changeTab', data)"
            @reload="$emit('reload')"
            @selectAll="selectAll"
    />

    <div class="table-filter-wrap">

      <EtsyTransferShopFilter
              :showFilter="showFilter"
              :filterGetParams="filterGetParams"
              @close="closeFilter"
              @changeFilter="data => $emit('changeFilter', data)"
              @resetFilter="$emit('resetFilter')"
      />

      <EtsyTransferShopTable
              :countFilterParams="countFilterParams"
              :selectedNow="selectedNow"
              @showMore="$emit('showMore')"
              @resetFilter="$emit('resetFilter')"
              @reload="$emit('reload')"
              @downloadFiles="$emit('downloadFiles')"
      />
    </div>
  </div>
</template>

<script>


  import EtsyTransferShopHead from "./EtsyTransferShopHead/EtsyTransferShopHead";
  import EtsyTransferShopTable from "./EtsyTransferShopTable/EtsyTransferShopTable";
  import EtsyTransferShopFilter from "./EtsyTransferShopFilter/EtsyTransferShopFilter";

  export default {
    name: "EtsyTransferShop",

    components: {
      EtsyTransferShopHead,
      EtsyTransferShopTable,
      EtsyTransferShopFilter,
    },

    props: {
      countFilterParams: Number,
      filterGetParams: Object,
    },

    data(){
      return{
        selectedNow: false,
        showFilter: false,
      }
    },

    methods: {
      closeFilter() {
        this.showFilter = false
      },

      toggleFilter() {
        this.showFilter = !this.showFilter
      },

      selectAll(val) {
        this.selectedNow = val
      },
    }
  }
</script>

<style scoped>

</style>


